var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#582BB8",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C16.6569 15 18 13.6569 18 12C18 10.3431 16.6569 9 15 9C13.3431 9 12 10.3431 12 12C12 13.6569 13.3431 15 15 15Z",
    fill: "#582BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.2C13.4087 16.2 11.8826 16.5371 10.7574 17.1372C9.63214 17.7373 9 18.5513 9 19.4V20.68C9 20.7648 9.06321 20.8462 9.17574 20.9062C9.28826 20.9662 9.44087 21 9.6 21H20.4C20.5591 21 20.7117 20.9662 20.8243 20.9062C20.9368 20.8462 21 20.7648 21 20.68V19.4C21 18.5513 20.3679 17.7373 19.2426 17.1372C18.1174 16.5371 16.5913 16.2 15 16.2Z",
    fill: "#582BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.e114ff53bc97b9834a78720223825d58.svg";
export { ForwardRef as ReactComponent };